import { Button } from '@chakra-ui/react';
import { useFormikContext } from 'formik';
import { FC } from 'react';

type Props = {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  isFullWidth?: boolean;
  name?: string;
}

export const ButtonSubmit: FC<Props> = ({
  children, size = "md", isFullWidth = false, name
}) => {
  const { isSubmitting } = useFormikContext();

  return (
    <Button
      type="submit"
      size={size}
      variant="primary"
      isFullWidth={isFullWidth}
      isLoading={isSubmitting}
      name={name}
    >
      { children }
    </Button>
  )
};
